<!-- <app-alert-modal *ngIf="alertSuccess"></app-alert-modal> -->

<div class="alert alert-success" *ngIf="alertSuccess">
  Survey launched successfully!
</div>
<div class="container top-space">
    <div class= "top-section">
      <h4>PREVIEW SURVEY - {{eventName}}</h4>
    </div>
    <div class="space"></div>
    <div class="fonts disable" *ngFor="let questions of allSelectedQuestions;let i=index">
      <p>{{i+1}}. {{questions.question}} </p>
      <div class="bottom-space">
       <div  *ngFor="let answer of selectedAnswers">
         <label *ngIf="(questions.questionId == answer.questionId)&&((questions.answerType).trim() == 'SELECT' )">       
            <input class="radio-align" type="radio" name="radio" [value]="answer.answerText"/> <span class="left-space"> {{answer.answerText}}</span></label>
         <span *ngIf="(questions.questionId == answer.questionId)&&((questions.answerType).trim() == 'TEXT' )">       
          <textarea class="form-control col-md-6" rows="3" ></textarea> </span>
     
       </div>
      </div> 
    </div>
    <div class="space"></div>
    <p class="text-center">
        <button type="button" id="launchButton" class="btn btn-danger col-sm-2 col-md-2 button-margin" (click)="launch()" [disabled]="alertSuccess">LAUNCH</button>
        <span class="col-md-1"></span>
        <button type="button" class="btn btn-danger col-sm-2 col-md-2 button-margin" (click)="cancelClick()" data-toggle="modal" data-target="#myModal" [disabled]="alertSuccess">CANCEL</button>
          <app-confirmation-modal [PData]="msg1" (emitPass)="this[previewMethod]()" id ="1"></app-confirmation-modal>
    </p> 
  
</div>  

